export const academyPrograms = [
  {
    id: 1,
    title: "About NBT",
    subtitle: "A Continuing Legacy",
    description: "NBT was formed in the spring of 2000 under the vision and direction of John Bishop and Maureen Skomerza. The hope was to build a high quality regional ballet company which would produce professional level classical and contemporary productions for audiences in the Puget Sound area. That vision soon became a reality when it produced its first spring production of Coppelia in 2001. With an unwavering commitment to excellence that was rooted in the history and traditions of classical ballet, NBT has continued to grow and evolve.",
    image: "/images/nbt-about.jpg",
    category: "About",
    featured: true
  },
  {
    id: 2,
    title: "Our Academy",
    subtitle: "History, Tradition, Excellence",
    description: "Northwest Ballet Academy strives to bring dance awareness to the community through professional dance training, performances, outreach programs and collaborations with Whatcom County's performing arts organizations. We provide opportunities for students interested in arts-related careers including choreography, teaching, stage production, publicity, costume design and set construction. Audition opportunities for national dance schools and performing companies are provided for students who are interested in expanding their training.",
    image: "/images/academy-overview.jpg",
    category: "Academy",
    featured: true
  },
  {
    id: 3,
    title: "Professional Instruction",
    subtitle: "Expert Faculty & Training",
    description: "Our professional instructors bring years of experience and expertise to every class. With backgrounds in prestigious ballet companies and schools, our faculty provides world-class training in a supportive environment that nurtures each student's individual growth and artistic development.",
    image: "/images/nba-teachers.jpg",
    category: "Instruction",
    highlights: [
      "Experienced professional faculty",
      "Individual attention and guidance",
      "Classical ballet technique",
      "Performance opportunities"
    ]
  },
  {
    id: 4,
    title: "Season 19",
    subtitle: "Tickets on Sale Now!",
    description: "Mount Baker Theatre: www.mountbakertheatre.com | McIntyre Hall: www.mcintyrehall.org. John Bishop, founder and artistic director of Northwest Ballet Theater reports his Nutcracker is like the original version based on the Russian ballet where it was first performed in St. Petersburg in 1892. Northwest Ballet's production features backdrops painted in Russia as well as costumes made in New York City.",
    image: "/images/season-19-slider.jpg",
    category: "Performances",
    callToAction: "Get Tickets",
    highlights: [
      "Authentic Russian Nutcracker production",
      "Hand-painted Russian backdrops",
      "New York City costumes",
      "Holiday tradition since 2001"
    ]
  },
  {
    id: 5,
    title: "Children's Division",
    subtitle: "Ages 3-4 Creative Dance",
    description: "The Children's program offers an introduction to the art of dance by promoting the exploration of creativity and expression through movement. These classes do not require a placement class. Creative Dance Ballet and dance concepts combine with imaginative play to encourage the development of each child's self-expression and creativity, large and fine motor skills, coordination and musical awareness.",
    image: "/images/little-girl-class.jpg",
    category: "Programs",
    ageRange: "3-4 years",
    locations: ["Bellingham", "Lynden"],
    highlights: [
      "Creative movement exploration",
      "Imaginative play integration",
      "Motor skills development",
      "Musical awareness building",
      "No previous experience required"
    ]
  },
  {
    id: 6,
    title: "Youth Division",
    subtitle: "Foundation Building Program",
    description: "The Youth Program offers an introduction to the art of dance by promoting the exploration of creativity and expression through movement. This program supports the development and improvement of motor skills and coordination, attention and listening skills, as a preparation for continued study of classical ballet. No previous ballet training is necessary. Our Youth Program is based on age, regardless of experience.",
    image: "/images/youth-division.jpg",
    category: "Programs",
    ageRange: "5-8 years",
    locations: ["Bellingham", "Lynden"],
    highlights: [
      "Age-based progression",
      "Motor skills development",
      "Attention and listening skills",
      "Classical ballet preparation",
      "Ongoing enrollment"
    ]
  },
  {
    id: 7,
    title: "Classical Ballet Program",
    subtitle: "Elementary Ballet III & IV",
    description: "Elementary Ballet III (EB III) - Emphasis is on increasing vocabulary, presentation, memorization and traveling combinations. Elementary Ballet IV (EB IV) - EB IV ballet level students are challenged to apply skills and execute moves with greater technical precision and artistic expression.",
    image: "/images/classical-ballet.jpg",
    category: "Programs",
    ageRange: "9+ years",
    locations: ["Bellingham", "Lynden"],
    highlights: [
      "Progressive skill development",
      "Technical precision focus",
      "Artistic expression training",
      "Performance preparation",
      "Dress code requirements"
    ],
    dressCodes: {
      girls: "Raspberry camisole leotard, pink tights, pink ballet shoes",
      boys: "Black tights, white T-shirt, black or white ballet shoes"
    }
  },
  {
    id: 8,
    title: "Academy Class Schedules",
    subtitle: "Bellingham & Lynden Locations",
    description: "View our complete class schedules for both Bellingham and Lynden locations. Classes are offered throughout the week to accommodate various schedules and age groups.",
    image: "/images/academy-schedule.jpg",
    category: "Schedules",
    locations: ["Bellingham", "Lynden"],
    callToAction: "View Schedules"
  },
  {
    id: 9,
    title: "Registration",
    subtitle: "Sign Up for Classes Today",
    description: "Sign up for class today, so that we can reserve your spot in the classroom. Your first class you will be asked to fill out a registration form and also sign a parental/guardian form (if under the age of 18 years). We will have forms available for you upon arrival or you may download the registration PDF form.",
    image: "/images/registration.jpg",
    category: "Registration",
    callToAction: "Register Now",
    highlights: [
      "Reserve your spot today",
      "Registration forms available",
      "Parental consent for minors",
      "Multiple class options",
      "Flexible enrollment"
    ]
  }
];

export const academyCategories = [
  "All",
  "About",
  "Academy", 
  "Programs",
  "Instruction",
  "Performances",
  "Schedules",
  "Registration"
];

export const locations = [
  {
    name: "Bellingham",
    address: "1417 Cornwall Avenue, Bellingham, WA 98225"
  },
  {
    name: "Lynden", 
    address: "Jansen Art Center, 321 Front Street, Lynden, WA 98264"
  }
];
